import { ConnectionModel } from '@em/models/restapi/Connection.Model';
import { ChangeTrackedCollectionModel } from '@shared/models/restapi/ChangeTrackedCollection.Model';

export class ConnectionCollectionModel extends ChangeTrackedCollectionModel<ConnectionModel> {
    public constructor() {
        super(ConnectionModel);
    }
}
